import { render, staticRenderFns } from "./BetaModal.vue?vue&type=template&id=26c53390&scoped=true&"
import script from "./BetaModal.vue?vue&type=script&lang=js&"
export * from "./BetaModal.vue?vue&type=script&lang=js&"
import style0 from "./BetaModal.vue?vue&type=style&index=0&id=26c53390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c53390",
  null
  
)

export default component.exports